import classNames from 'classnames';
import styles from './Kinoklubb.module.css';

//#region [Props]
type KinoklubbProps = {
    className?: string;
};
//#endregion

//#region [Component]
export default function Kinoklubb({ className }: KinoklubbProps) {
    return <div className={classNames(styles.SKinoklubb, className)}>
        * Halv pris på <a className={styles.SKinoklubbLink} href="https://www.kinoklubb.no/">Kinoklubb-forestillinger</a>
    </div>;
}
//#endregion

//#region [Styles]
//#endregion

